import React from 'react';
import type { MotorAd } from '../../../types';

type MotorLocationProps = {
    ad: MotorAd;
    className?: string;
};

export function MotorLocation(props: MotorLocationProps) {
    const { ad, className = '' } = props;

    const hasNewPrice = ad.flags.includes('new_price');

    return (
        <div className={className}>
            {hasNewPrice && (
                <span className="text-s s-text-subtle">Ny pris</span>
            )}
            {ad.location && (
                <span className="text-s s-text-subtle">{ad.location}</span>
            )}
        </div>
    );
}
